import DateFormat from './utilities/date-format';

export default class Header {

	static getHolderSelectors = () => ['header'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {Pikaday} */
	#checkInDatePicker;

	/** @type {Pikaday} */
	#checkOutDatePicker;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		this.#setNavBar();
		this.#setSideMenu();
		this.#setBooking();

		this.#holderElement.querySelector('.overlay').addEventListener('click', (e) => {
			this.#closeSideMenu(e);
			this.#closeBooking(e);
		});
	}

	#setNavBar() {
		if (!document.querySelector('.hero-element') && !document.querySelector('.room-nav-bar-element')) {
			document.querySelector('.header-position-holder').style.height = this.#holderElement.offsetHeight/16 + 'rem';
		}

		if (document.querySelector('.room-nav-bar-element')) {
			this.#holderElement.style.position = 'initial';
		}

		this.#holderElement.querySelectorAll('.btn-menu-col').forEach(menuIcon => {
			menuIcon.addEventListener('click', () => {
				menuIcon.querySelector('.menu-icon').classList.toggle('open');
			});
		});
	}

	#setSideMenu() {
		this.#holderElement.querySelector('.btn-side-menu').addEventListener('click', (e) => {
			this.#openSideMenu(e);
		});

		this.#holderElement.querySelector('.close-side-menu').addEventListener('click', (e) => {
			this.#closeSideMenu(e);
		});
	}

	#setBooking() {
		const arrivalInput = this.#holderElement.querySelector('[name="checkInDate"]');
		const departureInput = this.#holderElement.querySelector('[name="checkOutDate"]');

		this.#holderElement.querySelectorAll('.btn-booking').forEach(btnBooking => {
			btnBooking.addEventListener('click', (e) => {
				this.#openBooking(e);
			});
		});

		this.#holderElement.querySelector('.close-booking').addEventListener('click', (e) => {
			this.#closeBooking(e);
		});

		let checkInField = this.#holderElement.querySelector('.check-in-field');
		let checkOutField = this.#holderElement.querySelector('.check-out-field');

		this.#checkInDatePicker = new Pikaday({
			field: checkInField,
			minDate: new Date(),
			onSelect: (date) => {
				checkInField.value = DateFormat.format(date, DateFormat.CALENDAR);
				checkInField.dataset.date = DateFormat.format(date, DateFormat.ISO_8601);
				arrivalInput.value = DateFormat.format(date, DateFormat.ISO_8601);

				if (this.#checkOutDatePicker.getDate() < this.#checkInDatePicker.getDate()) {
					this.#checkOutDatePicker.setDate(DateFormat.addDays(date, 2));
				}
			},
		});

		this.#checkOutDatePicker = new Pikaday({
			field: checkOutField,
			minDate: new Date(),
			onSelect: (date) => {
				checkOutField.value = DateFormat.format(date, DateFormat.CALENDAR);
				checkOutField.dataset.date = DateFormat.format(date, DateFormat.ISO_8601);

				if (!arrivalInput.value) {
					return;
				}
				departureInput.value = DateFormat.format(date, DateFormat.ISO_8601);
			},
		});

		this.#checkInDatePicker.setDate(new Date());
		this.#checkOutDatePicker.setDate(DateFormat.addDays(new Date(), 2));
	}

	/** @param {HTMLElement} element */
	#handleTabSelection(element) {
		this.#holderElement.querySelector('.booking-switch-tab').querySelector('.active').classList.remove('active');
		element.classList.add('active');
	}

	/** @param {Event} e */
	#openSideMenu(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.side-menu').classList.add('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'visible';
		this.#holderElement.querySelector('.overlay').style.opacity = 1;
		document.querySelector('body').style.overflow = 'hidden';
	}

	/** @param {Event} e */
	#closeSideMenu(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.side-menu').classList.remove('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'hidden';
		this.#holderElement.querySelector('.overlay').style.opacity = 0;
		document.querySelector('body').style.overflow = 'unset';
	}

	/** @param {Event} e */
	#openBooking(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.booking').classList.add('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'visible';
		this.#holderElement.querySelector('.overlay').style.opacity = 1;
		document.querySelector('body').style.overflow = 'hidden';
	}

	/** @param {Event} e */
	#closeBooking(e) {
		e.preventDefault();
		this.#holderElement.querySelector('.booking').classList.remove('show');
		this.#holderElement.querySelector('.overlay').style.visibility = 'hidden';
		this.#holderElement.querySelector('.overlay').style.opacity = 0;
		document.querySelector('body').style.overflow = 'unset';
	}

}
